"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderRating = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */

/**
 * Function to render ratings/stars
 *
 * @param {object} rating Number of stars to fill in
 * @param {number} size Size of stars
 * @returns {array} Array of stars to render
 * @public
 */
const renderRating = (rating, size) => {
  const ratingBlock = [];
  const starColor = '#fff';
  const unfilledBg = '#DCDCE6';
  const filledBg = '#00B67B';
  let isHalf = false;
  let ratingNormalized = parseFloat(rating);
  if (ratingNormalized % 1 !== 0) {
    isHalf = true;
    ratingNormalized -= 1;
  }
  for (let i = 0; i < 5; i++) {
    ratingBlock.push(
    /*#__PURE__*/
    // Non-interactive elements like this fall outside the scope of ux-intents except for the figures intents. So other than figure colors, we use hard-coded hex colors.
    _react.default.createElement("svg", {
      key: i,
      xmlns: "http://www.w3.org/2000/svg",
      className: "trustpilot-star",
      width: size,
      height: size,
      viewBox: "0 0 18 18",
      fill: "none"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M18.0002 0H9.00537V18.0001H18.0002V0Z",
      fill: i < ratingNormalized ? filledBg : unfilledBg
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M9.00524 0H0V18.0001H9.00524V0Z",
      fill: i < ratingNormalized || isHalf && i < ratingNormalized + 1.5 ? filledBg : unfilledBg
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M9.00575 12.1358L11.7397 11.4366L12.8771 14.9636L9.00575 12.1358ZM15.2666 7.57576H10.4771L9.00575 3.03662L7.56575 7.56533H2.70312L6.60575 10.3723L5.12401 14.8697L9.01619 12.0627L11.4162 10.3306L15.298 7.56533L15.2666 7.57576Z",
      fill: starColor
    })));
  }
  return ratingBlock;
};
exports.renderRating = renderRating;